import http from "./http-common";

class TransactionDataService {
    getAll() {
      return http.get("/transactions-p");
    }

    getForLocation(locationId, begin, end) {
      return http.get(`/transactions-p?begin=${begin}&end=${end}&locationId=${locationId}`);
    }
    getForDates(begin, end) {
      return http.get(`/transactions-p?begin=${begin}&end=${end}`);
    }
    getTransfers(locationId, begin, end) {
      return http.get(`/transactions-p/transfers?begin=${begin}&end=${end}&locationId=${locationId}`);
    }
    
    get(id) {
      return http.get(`/transactions-p/${id}`);
    }
  
    create(data) {
        return http.post("/transactions-p", data);
    }

    delete(id) {
      return http.delete(`/transactions-p/${id}`);
    }
}

export default new TransactionDataService();